var Counter = function(){
    
    var key = 'cwp-dismiss-count',
        timestampKey = 'cwp-last-dismissed';
    
    this.count = function(){
        return parseInt(window.localStorage.getItem(key)) || 0;
    }
    
    this.getStorageKey = function(){
        return key;
    }
    
    this.dismiss = function(){
        var dismissedCounter = this.count();
        window.localStorage.setItem(key, ++dismissedCounter);
        window.localStorage.setItem(timestampKey, Date.now() / 1000);
    }
    
    this.getLastDismissTimestamp = function(){
        if (!this.count()) {
            throw 'no dismesses yet';
        }
        return parseInt(window.localStorage.getItem(timestampKey));
    }
    
    this.dismissOlderThan = function(seconds){
        if (!this.count()) return true;
        if (this.getLastDismissTimestamp() + seconds < Date.now() / 1000) {
            return true;
        } else {
            return false;
        }
    }
};

export default new Counter;
    


//////////////////
// WEBPACK FOOTER
// ./src/utils/storage/dismiss-storage.js
// module id = 0
// module chunks = 0